import { Alert, Typography } from '@sravni/react-design-system';
import type { AlertProps } from '@sravni/react-design-system/dist/types/components/Alert/types/Alert.types';
import type { TextProps } from '@sravni/react-design-system/dist/types/components/Typography/types/Text.types';
import cn from 'classnames';
import type { ComponentPropsWithoutRef } from 'react';

import styles from './AnketaAlert.module.scss';

type IAnketaAlert = AlertProps & {
  title?: string | React.ReactNode;
  subtitle: string | React.ReactNode;
  titleSize?: TextProps['size'];
  subtitleSize?: TextProps['size'];
};

type Props = ComponentPropsWithoutRef<'div'> & IAnketaAlert;

export const AnketaAlert: FC<Props> = ({
  title,
  subtitle,
  titleSize = 14,
  subtitleSize = 14,
  color = 'orange',
  variant = 'primary',
  className,
  icon,
  ...props
}) => (
  <Alert
    {...props}
    color={color}
    variant={variant}
    icon={icon}
    title={
      title && (
        <Typography.Text
          strong
          size={titleSize}
        >
          {title}
        </Typography.Text>
      )
    }
    subtitle={<Typography.Text size={subtitleSize}>{subtitle}</Typography.Text>}
    className={cn(styles.anketaAlert, className)}
  />
);
